import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { useEventCallback } from '@mui/material';
import { EditAmountCrubs } from 'front-office/constants/amount-crubs';
import FormAmount, { AmountForm } from 'front-office/components/amount/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ResponseAmount } from 'shell/models/response-amount';
import { HttpResponse } from 'shell/models/http-response';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { transformerAmount } from 'front-office/utils/transformer-amount';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { transformerDatasetAmount } from 'front-office/utils/transformer-dataset-amount';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const EditAmount = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [importo] = useHttpFetch<HttpResponse<ResponseAmount>, AmountForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/importo-pagamento/${params.codice}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformerAmount,
    }
  );

  const updateData = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/importo-pagamento/${params.codice}`,
    { options: { method: 'PUT' } }
  );

  const onSubmit = useEventCallback((values?: AmountForm) => {
    const data = transformerDatasetAmount(values || {});

    (updateData({ data }) as ResponsePromise<void>).then(() => {
      toast.success('Operazione eseguita con successo');

      navigate('/sportello/ricerca-importo');
    });
  });

  const onCancel = useEventCallback(() => {
    navigate('/sportello/ricerca-importo');
  });

  return (
    <Fragment>
      <Breadcrumbs items={EditAmountCrubs} />
      {importo.data ? (
        <FormAmount
          title="Modifica Importo Pagamento"
          onSubmit={onSubmit}
          onCancel={onCancel}
          initialValues={importo.data as AmountForm}
          isEdit
        />
      ) : undefined}
    </Fragment>
  );
};

EditAmount.displayName = 'Edit Amount component';

export default EditAmount;
